import { PageViewEvent } from 'analytics-api';
import { AnalyticsGTMSettings } from './analytics-data.model';

export const isPageViewEvent = (settings: AnalyticsGTMSettings): settings is PageViewEvent => settings.event === 'pageview' || settings.event === 'popupview';
